/* eslint-disable import/order */
import AppBar from '@material-ui/core/AppBar'
import Dialog from '@material-ui/core/Dialog'
import IconButton from '@material-ui/core/IconButton'
import withStyles from '@material-ui/core/styles/withStyles'
import Toolbar from '@material-ui/core/Toolbar'
import Typography from '@material-ui/core/Typography'
import CloseIcon from '@material-ui/icons/Close'
import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import styles from '../../../resources/theme/users'
import Transiction from '../../components/Transition'
import { edit, update } from '../KnowWayActions'
import Form from './Form'
import BaseFilterModal from '../../../components/hooks/BaseFilterModal'
import { Grid } from '@material-ui/core'
import { useHistory } from 'react-router-dom'

const Transition = React.forwardRef((props, ref) => {
  return <Transiction propis={props} refi={ref} />
})

function EditType(props) {
  const { classes } = props
  const dispatch = useDispatch()
  const history = useHistory()

  const service = useSelector(state => state.knowWay.editingknowWay)

  const onSubmit = values => {
    dispatch(update(values)).then(data => {
      onClose()
    })
  }

  const onClose = () => {
    history.goBack()
  }

  useEffect(() => {
    dispatch(edit(props.match.params.id))
  }, [])

  return (
    <BaseFilterModal
      open
      handleOpen={onClose}
      title="Editar como conheceu"
      hiddenHelpButton
    >
      <Grid item container xs={12} style={{ width: '250px' }}>
        <Grid item container xs={12} style={{ marginTop: '.5em' }}>
          <Form
            classes={classes}
            data={service}
            onClose={onClose}
            onSubmit={onSubmit}
          />
        </Grid>
      </Grid>
    </BaseFilterModal>
  )
}

export default withStyles(styles)(EditType)
